
import deepCopy from '@/utils/copy';
import { TripLog } from '@clients/myTrips';
import DateInput from '@components/new-styleguide/form/DateInput.vue';
import FilterModal from '@components/new-styleguide/HeaderModal.vue';
import {
  calculateFromAndUntilDates,
  DatePeriod,
  isoDateToDateString,
  textFromDatePeriod
} from '@util/dates-and-times/period';
import { today } from '@util/dates-and-times';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const TriplogModule = namespace('Triplog');

export interface StatisticFiltersModel {
  datePeriod: DatePeriod,
  from: string,
  until: string
}

@Component({
  name: 'StatisticFilterModal',
  components: {
    FilterModal,
    DateInput
  }
})
export default class StatisticFilterModal extends Vue {
  @Prop()
  private value: StatisticFiltersModel;

  @Prop({ default: false })
  private open: boolean;

  @TriplogModule.Getter('getSelectedTriplog')
  private triplog: TripLog;

  private input: StatisticFiltersModel = null;

  private DatePeriod = DatePeriod;

  created() {
    this.input = deepCopy(this.value);
  }

  @Watch('open')
  private onOpenChanged(newOpen) {
    if (newOpen) { // reset original value
      this.input = deepCopy(this.value);
    }
  }

  get today() {
    return today();
  }

  get lastTripDate() {
    return this.triplog && this.triplog?.lastTripTimestamp ? new Date(this.triplog.lastTripTimestamp) : new Date();
  }

  get inputFrom() {
    return isoDateToDateString(this.input.from);
  }

  get inputUntil() {
    return isoDateToDateString(this.input.until);
  }

  private datePeriodText(datePeriod: DatePeriod) {
    return textFromDatePeriod(datePeriod, this.lastTripDate);
  }

  private setInputFrom(value: string) {
    this.input.from = new Date(value).toISOString();
    this.switchToCustomPeriod();
  }

  private setInputUntil(value: string) {
    this.input.until = new Date(value).toISOString();
    this.switchToCustomPeriod();
  }

  private switchToCustomPeriod() {
    this.input.datePeriod = DatePeriod.CUSTOM;
  }

  private changeDatePeriod(datePeriod: DatePeriod) {
    const { from, until } = calculateFromAndUntilDates(datePeriod, this.lastTripDate);
    this.input = { ...this.input, from, until };
  }

  private submit() {
    this.$emit('submit', this.input);
  }
}
